import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ServiceType } from "../_types/services-types";
import { ServiceTypeCompany } from "../_types/services-types-companies";

@Injectable({
    providedIn: 'root',
})

export class ServicesTypesCompaniesService extends Service<ServiceTypeCompany> {
  public override type = 'serviceTypesCompanies';
  public override url = 'attendance/serviceTypeCompanies';
    
}
